import { render, staticRenderFns } from "./Addnew_tech.vue?vue&type=template&id=b39dad82&scoped=true&"
import script from "./Addnew_tech.vue?vue&type=script&lang=js&"
export * from "./Addnew_tech.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b39dad82",
  null
  
)

export default component.exports